import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CreateWaveGroupSearchField from "./CreateWaveGroupSearchField";
export default function CreateWaveInlineGroupSearch(t0) {
  const $ = _c(6);
  const {
    defaultLabel,
    disabled,
    selectedGroup,
    allowGroupClear: t1,
    onSelect
  } = t0;
  const allowGroupClear = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== allowGroupClear || $[1] !== defaultLabel || $[2] !== disabled || $[3] !== onSelect || $[4] !== selectedGroup) {
    t2 = <div className="tw-space-y-3"><CreateWaveGroupSearchField label={"Search groups\u2026"} defaultLabel={defaultLabel} disabled={disabled} selectedGroup={selectedGroup} allowClear={allowGroupClear} onSelect={onSelect} /></div>;
    $[0] = allowGroupClear;
    $[1] = defaultLabel;
    $[2] = disabled;
    $[3] = onSelect;
    $[4] = selectedGroup;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}